'use client';

import { IconCopy, IconDownload, IconMinus, IconPlus } from '@tabler/icons-react';
import { Cbutton } from '../Cbutton';
import { ButtonPreset } from '@/constants/componentPresets';
import {
  ICON_BTN_CONTAINER_STYLE,
  ICON_BTN_ICON_SIZE,
  ICON_BTN_RADIUS,
  ICON_BTN_SIZE,
  MAX_FONT_SIZE_PX,
  MIN_FONT_SIZE_PX,
} from './cmarkdowncodeConstants';

interface CmarkdowncodeControlsProps {
  fontSizePx: number;
  onCopy: () => void;
  onDownload: () => void;
  onFontDecrease: () => void;
  onFontIncrease: () => void;
}

export function CmarkdowncodeControls({
  fontSizePx,
  onCopy,
  onDownload,
  onFontDecrease,
  onFontIncrease,
}: CmarkdowncodeControlsProps) {
  const canDecrease = fontSizePx > MIN_FONT_SIZE_PX;
  const canIncrease = fontSizePx < MAX_FONT_SIZE_PX;

  return (
    <>
      <Cbutton
        icon={IconMinus}
        iconSize={ICON_BTN_ICON_SIZE}
        preset={ButtonPreset.Ghost}
        radius={ICON_BTN_RADIUS}
        padding={0}
        height={ICON_BTN_SIZE}
        containerStyle={ICON_BTN_CONTAINER_STYLE}
        onClick={onFontDecrease}
        disabled={!canDecrease}
      />
      <Cbutton
        icon={IconPlus}
        iconSize={ICON_BTN_ICON_SIZE}
        preset={ButtonPreset.Ghost}
        radius={ICON_BTN_RADIUS}
        padding={0}
        height={ICON_BTN_SIZE}
        containerStyle={ICON_BTN_CONTAINER_STYLE}
        onClick={onFontIncrease}
        disabled={!canIncrease}
      />
      <Cbutton
        icon={IconCopy}
        iconSize={ICON_BTN_ICON_SIZE}
        preset={ButtonPreset.Ghost}
        radius={ICON_BTN_RADIUS}
        padding={0}
        height={ICON_BTN_SIZE}
        containerStyle={ICON_BTN_CONTAINER_STYLE}
        onClick={onCopy}
      />
      <Cbutton
        icon={IconDownload}
        iconSize={ICON_BTN_ICON_SIZE}
        preset={ButtonPreset.Ghost}
        radius={ICON_BTN_RADIUS}
        padding={0}
        height={ICON_BTN_SIZE}
        containerStyle={ICON_BTN_CONTAINER_STYLE}
        onClick={onDownload}
      />
    </>
  );
}
